import { _elements } from './_elements';
import { _scroll } from './_scroll';

/*
 * This function adds 'draggable'-functionality to sliders.
 */
export const _drag = ( slider = null ) => {
	const {
		list,
		items,
	} = _elements( slider );

	const position = {
		initial: 0,
		final: 0,
		start: 0,
		end: 0,
		threshold: slider.clientWidth * 0.1,
	};

	const onDragStart = ( e ) => {
		position.initial = list.scrollLeft;

		if ( e.type === 'touchstart' ) {
			position.start = position.initial + e.touches[ 0 ].clientX;
		} else {
			position.start = position.initial + e.clientX;
			document.onmouseup = onDragEnd;
			document.onmousemove = onDragMove;
		}
	};

	const onDragMove = ( e ) => {
		if ( e.type === 'touchmove' ) {
			position.end = position.start - e.touches[ 0 ].clientX;
		} else {
			position.end = position.start - e.clientX;
		}

		list.scrollTo( { left: list.offsetLeft + position.end } );
	};

	const onDragEnd = () => {
		position.final = list.scrollLeft;

		const {
			current,
		} = _elements( slider );

		if ( position.final - position.threshold > position.initial && items[ current ] ) {
			_scroll( slider, items[ current ] );
		} else if ( position.final + position.threshold < position.initial && items[ current ] ) {
			_scroll( slider, items[ current ] );
		} else {
			list.scrollTo( { left: position.initial, behavior: 'smooth' } );
		}

		document.onmouseup = null;
		document.onmousemove = null;
	};

	list.onmousedown = onDragStart;
	list.addEventListener( 'touchstart', onDragStart );
	list.addEventListener( 'touchmove', onDragMove );
	list.addEventListener( 'touchend', onDragEnd );
};
